// Bussola che gira mentre la pagina carica: la rosa dei venti del logo Wanted
export default function BussolaLoader({ testo = "Apro il caveau...", testid = "bussola-loader" }) {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-5" data-testid={testid} role="status" aria-live="polite">
      <img
        src="/logo-bussola.png"
        alt=""
        aria-hidden
        className="w-14 h-14 animate-[spin_2.6s_linear_infinite] opacity-90 drop-shadow-[0_0_18px_rgba(220,38,38,0.35)]"
        draggable={false}
      />
      <span className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-600 animate-pulse">{testo}</span>
    </div>
  );
}
